import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'shared/components';
import React, { PureComponent } from 'react';

import isMobile from 'shared/utils/checkMobileDevice';
import { RemoteAudioDisabled, RemoteVideoDisabled, RemoteAudioVideoDisabled } from '../RemoteMedia';
import VideoStream from '../VideoStream';
import SoundLevel from '../SoundLevel';
import ToggleAudio from '../ToggleAudio';
import ToggleVideo from '../ToggleVideo';
import theme from './RemoteVideo.scss';
import localVideoTheme from '../LocalVideo/LocalVideo.scss';


const RemoteVideo = class RemoteVideo extends PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    isMCU: PropTypes.bool,
    isSwitched: PropTypes.bool,
    videoDisabled: PropTypes.bool,
    audioDisabled: PropTypes.bool,
    videoConnected: PropTypes.bool,
    isCallInProgress: PropTypes.bool,
    isCanStartCall: PropTypes.bool,
    conferenceInProgress: PropTypes.bool,
    outputSoundLevel: PropTypes.number,
    prevOutputSoundLevel: PropTypes.number,
    getMediaStream: PropTypes.func.isRequired,
    placeholder: PropTypes.any.isRequired,
    setSoundLevel: PropTypes.func.isRequired,
    setPrevSoundLevel: PropTypes.func.isRequired,
    isInWaitingRoom: PropTypes.bool.isRequired,
    endCallAction: PropTypes.func.isRequired,
    isConversationInProgressStatus: PropTypes.bool.isRequired,

    isAudioMuted: PropTypes.bool,
    isVideoMuted: PropTypes.bool,
    disabledEndButton: PropTypes.bool,
    reconnection: PropTypes.bool.isRequired,

    muteAudio: PropTypes.func.isRequired,
    unmuteAudio: PropTypes.func.isRequired,
    muteVideo: PropTypes.func.isRequired,
    unmuteVideo: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isMCU: false,
    isSwitched: false,
    videoDisabled: false,
    audioDisabled: false,
    videoConnected: false,
    conferenceInProgress: false,
    outputSoundLevel: 100,
    prevOutputSoundLevel: null,
    isCallInProgress: false,
    isCanStartCall: false,
    isAudioMuted: false,
    isVideoMuted: false,
    disabledEndButton: false,
  };

  constructor(props) {
    super(props);
    this.state = ({ stream: null });
    this.isMobile = isMobile();
  }

  componentDidMount() {
    const { getMediaStream, videoConnected, isMCU } = this.props;

    if (!videoConnected && !isMCU) return null;

    return getMediaStream()
      .then(stream => this.setState({ stream }));
  }

  componentWillReceiveProps(nextProps) {
    const { getMediaStream } = nextProps;
    const { stream } = this.state;
    const hasSwitched = nextProps.isSwitched !== this.props.isSwitched;

    if (!hasSwitched && stream && stream.active) return;

    return getMediaStream()
      .then(newStream => this.setState({ stream: newStream }));
  }

  componentWillUnmount() {
    if (this.state.stream) delete this.state.stream;
  }

  render() {
    const {
      intl,
      isMCU,
      audioDisabled,
      isInWaitingRoom,
      videoConnected,
      outputSoundLevel,
      setSoundLevel,
      prevOutputSoundLevel,
      conferenceInProgress,
      setPrevSoundLevel,
      isCallInProgress,
      endCallAction,
      placeholder,
      isCanStartCall,
      isAudioMuted,
      isVideoMuted,
      isSwitched,
      videoDisabled,
      muteAudio,
      unmuteAudio,
      muteVideo,
      unmuteVideo,
      disabledEndButton,
      reconnection,
      isConversationInProgressStatus,
    } = this.props;

    const { stream } = this.state;

    const videoParams = {
      stream,
      volume: outputSoundLevel,
      muted: isSwitched,
    };

    return (
      <div className={ theme.root } >
        <div>
          <If condition={ !isSwitched && audioDisabled && !videoDisabled }>
            <RemoteAudioDisabled />
          </If>
          <If condition={ !isSwitched && !audioDisabled && videoDisabled }>
            <RemoteVideoDisabled />
          </If>
          <If condition={ !isSwitched && audioDisabled && videoDisabled }>
            <RemoteAudioVideoDisabled />
          </If>
        </div>

        <If condition={ !videoConnected || reconnection || isInWaitingRoom }>
          { React.createElement(placeholder) }
        </If>

        <If condition={ videoConnected && stream && !reconnection && !isInWaitingRoom && (isConversationInProgressStatus || !isMCU) }>
          <div
            className={ classnames(theme.videoContainer, {
              [theme.disabledVideo]: videoDisabled && !isSwitched && !isMCU,
            }) }
          >
            <VideoStream { ...videoParams } />
          </div>
        </If>

        <If condition={ isCanStartCall || isCallInProgress }>
          <div className={ theme.buttonsContainer }>
            <div className={ classnames({ [theme.marginBottom]: isMobile() }) }>
              <SoundLevel
                outputSoundLevel={ outputSoundLevel }
                prevOutputSoundLevel={ prevOutputSoundLevel }
                setSoundLevel={ setSoundLevel }
                setPrevSoundLevel={ setPrevSoundLevel }
                muted={ isSwitched }
              />
            </div>
            <div className={ theme.conferenceButtonContainer }>
              { conferenceInProgress &&
                <Button
                  testId="end-consultation-button"
                  ariaLabel={ intl.formatMessage({
                    id: 'ConversationScreen.EndCallButton.TitleAttribute',
                    defaultMessage: '** End the call',
                  }) }
                  className={ theme.button }
                  buttonType="circle"
                  iconName="hangout"
                  size="large"
                  mediaResized={ true }
                  background="red"
                  disabled={ disabledEndButton }
                  onClick={ endCallAction }
                />
              }
            </div>
            <div>
              { isCallInProgress && (isSwitched || isMCU) && (
                <div className={ classnames(localVideoTheme.controls, theme.controls) }>
                  <ToggleAudio
                    isActive={ isAudioMuted }
                    activate={ muteAudio }
                    deactivate={ unmuteAudio }
                  />
                  <ToggleVideo
                    isActive={ isVideoMuted }
                    activate={ muteVideo }
                    deactivate={ unmuteVideo }
                  />
                </div>
              ) }
            </div>
          </div>
        </If>
      </div>
    );
  }
};

export default RemoteVideo;
